var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.5312C11.3624 15.5312 11.6562 15.2374 11.6562 14.875V9.625C11.6562 9.26257 11.3624 8.96875 11 8.96875C10.6376 8.96875 10.3438 9.26257 10.3438 9.625V14.875C10.3438 15.2374 10.6376 15.5312 11 15.5312Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.125C11.4833 6.125 11.875 6.51675 11.875 7C11.875 7.48324 11.4833 7.875 11 7.875C10.5167 7.875 10.125 7.48324 10.125 7C10.125 6.51675 10.5167 6.125 11 6.125Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.59375 10.5C1.59375 5.30507 5.80507 1.09375 11 1.09375C16.195 1.09375 20.4062 5.30507 20.4062 10.5C20.4062 15.695 16.195 19.9062 11 19.9062C5.80507 19.9062 1.59375 15.695 1.59375 10.5ZM11 2.40625C6.52995 2.40625 2.90625 6.02995 2.90625 10.5C2.90625 14.97 6.52995 18.5937 11 18.5937C15.47 18.5937 19.0937 14.97 19.0937 10.5C19.0937 6.02995 15.47 2.40625 11 2.40625Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/i_icon.c24357842d98371aeced9b8f44e27746.svg";
export { ForwardRef as ReactComponent };